import React from 'react';
import cn from 'classnames';
import Sticky from 'react-stickynode';
import { Link, useSearchParams } from 'react-router-dom';
import { useConfig } from 'config/ConfigContext';

import style from './style.scss';

const Header = () => {
  const { envLabel } = useConfig();
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');

  return (
    // Global Header
    <Sticky
      enabled
      innerZ={10}
      activeClass={style.stickyHeader}
    >
      <header className={style['site-header']} role="banner">
        <nav className={style['top-bar']}>
          <div className={style['top-bar-left']}>
            <div className={cn(style['top-bar-title'], style['site-desktop-title'], style.topbar)}>
              <Link to={`${key ? `/fsl/application?key=${key}` : '/fsl/application'}`}>LendingUSA</Link>
              { envLabel && envLabel !== 'production' && <div className={style.envLabel}>{ envLabel }</div> }
            </div>
          </div>
          <div className={style['top-bar-right']}>
            <a href="tel:+19496945001" className={style.phone}><span>Questions?</span> 949-694-5001</a>
          </div>
        </nav>
      </header>
    </Sticky>
    // End Global Header
  );
};

export default Header;
